module.exports = __webpack_public_path__ + "img/W5.ba8d7047.png";